// @ts-nocheck


import React from 'react';

import notification from 'antd/lib/notification';

import { measuringDeviceCertificationApi } from './../../../../../lib/api';
import { Header, Section } from './../../../../../components/layout';
import { GroupListTable } from './../../lib';

import { Tabs, Filter } from '../';

export default class extends GroupListTable {
  fetch = async (page = 1) => {
    const params = {
      ...super.fetch(page)
    };
    try {
      const data = await measuringDeviceCertificationApi.groupedList(params);
      this.setState({ ...data, loading: false, page });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  render() {
    return (
      <>
        <Header left={<h1>Исполнение бюджета</h1>} />
        <Tabs />
        <Section>
          {this.renderFilter(Filter)}
          {this.renderTable()}
        </Section>
      </>);

  }
}
